import React, { useEffect, useState } from "react";
import { Button, Dropdown, Menu, Card, Row, Col, Typography, Modal, Input, DatePicker, Table, Spin, message, Select, } from "antd";
import { ResponsivePie } from '@nivo/pie';
import dayjs from "dayjs";
import { Link, useAsyncValue } from "react-router-dom";
import Cookies from 'js-cookie';
import { BASE_URL, DateFormat } from '../Components/Constant';
import ApiService from "./apiService";
import HoverCard from './HoverCardForProcess';
import { getConfirmLocale } from "antd/es/modal/locale";

const { Title } = Typography;
const { Option } = Select;


const SummaryTab = ({
    pieData,
    inventory,
    batchLineItem,
    recordData,
    allFinishedProducts,
    selectedFinishedProductForProcess,
    setSelectedFinishedProductForProcess,
    selectedBagProductForProcess,
    allBagProducts,
    setSelectedBagProductForProcess,
    bagWeight,
    setRecordData,
    extractNumericQuantity

}) => {
    const [stockIn, setStockIn] = useState(false);
    const currentUserId = Cookies.get('userId');
    const CurrenctUserName = Cookies.get('name');
    const [rawMixProduct, setRawMixProduct] = useState([]);
    const [batchDateTime, setBatchDateTime] = useState('');
    const [notes, setNotes] = useState('');
    const [stock, setStock] = useState();
    const [stockId, setStockId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [approved, setApproved] = useState(false);
    const [requestForApproval, setRequestForApproval] = useState(false);
    const [processIn, setProcessIn] = useState(false);
    const [startPackaging, setStartPackaging] = useState(false);
    const [processStartDate, setProcessStartDate] = useState();
    const [processEndDate, setProcessEndDate] = useState();
    const [totalQuantityForProcess, setTotalQuantityForProcess] = useState();
    const [processId, setProcessId] = useState();
    const [process, setProcess] = useState([]);
    const [notesForProcess, setNotesForProcess] = useState();
    const [pendingForApproval, setPendingForApproval] = useState(false);
    const [packaging, setPackage] = useState([]);
    const [packageId, setPackageId] = useState(null);
    const [notesForPackage, setNotesForPackage] = useState(null);
    const [totalQuantityForPackage, setTotalQuantityForPackage] = useState(null);
    const [users, setUsers] = useState([]);
    const [ownerForProcess, setOwnerForProcess] = useState();
    const [ownerForPackage, setOwnerForPackage] = useState();
    const [packageProductForProcess, setPackageProductForProcess] = useState(null);
    const [packageProductForPackage, setPackageProductForPackage] = useState(null);
    const [hoveredProcess, setHoveredProcess] = useState([]);
    const [EndmodalVisible, setEndModalVisible] = useState(false);
    const [processQuantityToEnd, setProcessQuantityToEnd] = useState(null);
    const [productForPackageFromProcessing, setProductForPackageFromProcessing] = useState(null);
    const [hoverVisible, setHoverVisible] = useState(false);
    const [hoverPosition, setHoverPosition] = useState({ top: 0, left: 0 });
    const [finalFinishedProduct, setFinalFinishedProduct] = useState([]);
    const [processItemtoEnd, setProcessItemToEnd] = useState([]);
    const [expectedPackagingBagsForProcess, setExpectedPackagingBagsForProcess] = useState(null);
    const [expectedPackagingBagsForPackage, setExpectedPackagingBagsForPackage] = useState(null);
    const [dispatchModal, setDispatchModal] = useState(false);
    const [dispatched, setDispatched] = useState(false);
    const [dispatchId, setDispatchId] = useState(null);
    const [order, setOrders] = useState([]);
    const [selectedOrderForDispatch, setSelectedOrderForDispatch] = useState(null);
    const [dispatchDate, setDispatchDate] = useState(null);
    const [dispatchTruckNumber, setDispatchTruckNumber] = useState(null);
    const [dispatchDriverName, setDispatchDriverName] = useState(null);
    const [ownerForDispatch, setOwnerForDispatch] = useState(null);

    useEffect(() => {
        if (recordData?._id) {
            getBatchLifeCycleData();
        }
    }, []);

    useEffect(() => {
        if (selectedFinishedProductForProcess) {
            fetchFinishedProduct();
        }
    }, [selectedFinishedProductForProcess])


    const fetchFinishedProduct = async () => {
        try {
            const apiService = new ApiService(
                `${BASE_URL}/fetch_single_record/Product/${selectedFinishedProductForProcess}`,
                { 'Content-Type': 'application/json' },
                'GET',
            );
            const res = await apiService.makeCall();
            setFinalFinishedProduct(res);

        }
        catch (error) {

        }

    }

    useEffect(() => {
        if (!processEndDate) {
            setProcessEndDate(dayjs().format("DD/MM/YYYY hh:mm A"));
        }
        if (!processStartDate) {
            setProcessStartDate(dayjs().format("DD/MM/YYYY hh:mm A"));
        }
        if (!dispatchDate) {
            setDispatchDate(dayjs().format("DD/MM/YYYY hh:mm A"));
        }
    }, [processEndDate, processStartDate, dispatchDate]);

    useEffect(() => {
        if (recordData?._id) {
            setBatchDateTime(dayjs(recordData?.BatchDateTime).utc().format('DD/MM/YYYY hh:mm A'));
        }
    }, []);


    useEffect(() => {
        if (recordData?._id) {
            if (recordData?.ApprovalStatus === 'Approved') {
                setApproved(true);
            }
        }
    }, [recordData]);


    const getBatchLifeCycleData = async () => {
        try {
            setLoading(true);
            const Users = new ApiService(`${BASE_URL}/fetch_records/User`, { 'Content-Type': 'application/json' }, 'GET');
            const responseUsers = await Users.makeCall();
            setUsers(responseUsers?.records);
            const rawMix = {
                _id: "67ac342399c6025ebe31314e",
                Name: "RawMix 7",
            }
            setRawMixProduct(rawMix);
            if (recordData?.Status === "Stocked" || recordData?.Status === "In Processing" || recordData?.Status === "Packaged" || recordData?.Status === "Partially Packaged" || recordData?.Status === "Dispatched") {
                const getStock = new ApiService(`${BASE_URL}/fetch_records_parent_childs/BatchOutputLineItem/Batch_id/${recordData?._id}`, { 'Content-Type': 'application/json' }, 'GET');
                const responseStock = await getStock.makeCall();
                setStock(responseStock[0]);
                setStockId(responseStock[0]?._id);
            }

            if (recordData?.Status === "In Processing" || recordData?.Status === "Packaged" || recordData?.Status === "Partially Packaged" || recordData?.Status === "Dispatched") {
                const getProcess = new ApiService(`${BASE_URL}/fetch_records_parent_childs/Processing/Batch_id/${recordData?._id}`, { 'Content-Type': 'application/json' }, 'GET');
                const responseProcess = await getProcess.makeCall();
                setProcessId(responseProcess[responseProcess.length - 1]._id)
                setProcess(responseProcess);
            }
            if (recordData?.Status === "Packaged" || recordData?.Status === "Partially Packaged" || recordData?.Status === "Dispatched") {
                const getPackage = new ApiService(`${BASE_URL}/fetch_records_parent_childs/PacakgedOutput/Batch_id/${recordData?._id}`, { 'Content-Type': 'application/json' }, 'GET');
                const responsePackage = await getPackage.makeCall();
                setPackageId(responsePackage[responsePackage.length - 1]._id);
                setPackage(responsePackage[responsePackage.length - 1]);
            }



            // const Order = new ApiService(`${BASE_URL}/fetch_records/Order`, { 'Content-Type': 'application/json' }, 'GET');
            // const responseOrder = await Order.makeCall();
            // setOrders(responseOrder);


        }
        catch (error) {
        }
        finally {
            setLoading(false);
        }
    }

    const fetchBatch = async () => {
        setLoading(true);
        try {
            const Batch = new ApiService(
                `${BASE_URL}/fetch_single_record/Batch/${recordData?._id}`,
                { "Content-Type": "application/json" },
                "GET"
            );

            const data = await Batch.makeCall();

            setRecordData(data);

        }
        catch (error) {

        } finally {
            setLoading(false);

        }
    }

    const onApproval = async () => {
        setLoading(true);
        try {
            const apiService = new ApiService(
                `${BASE_URL}/approvals/create/Batch/${recordData?._id}`,
                {
                    "Content-Type": "application/json",
                },
                "POST"
            );

            const response = await apiService.makeCall();
            message.success('Batch requested for approval');

            fetchBatch();
        }

        catch (error) {

        } finally {
            setLoading(false);
        }
    }

    const onStockIn = () => {
        setStockIn(true);
    }

    const handleStockInConfirm = async () => {
        setLoading(true);
        try {
            const body = {
                object_name: "BatchOutputLineItem",
                data: {
                    User_id: currentUserId,
                    OutputProduct_id: rawMixProduct?._id,
                    Batch_id: recordData?._id,
                    Quantity: recordData?.TotalQuantity,
                    Note: notes,
                }
            }

            const apiService = new ApiService(
                `${BASE_URL}/insert_or_update_records`,
                { 'Content-Type': 'application/json' },
                'POST',
                body
            );

            const response = await apiService.makeCall();
            const id = response.id
            setStockIn(false);

            const bodyToUpdate = {
                object_name: "Batch",
                data: {
                    _id: recordData?._id,
                    Status: "Stocked"
                }
            }
            const apiServiceBatch = new ApiService(
                `${BASE_URL}/insert_or_update_records`,
                { 'Content-Type': 'application/json' },
                'POST',
                bodyToUpdate
            );
            const resp = await apiServiceBatch.makeCall();

            const getData = new ApiService(`${BASE_URL}/fetch_single_record/BatchOutputLineItem/${id}`, { 'Content-Type': 'application/json' }, 'GET');
            const responseData = await getData.makeCall();
            setStock(responseData);
            setStockId(responseData._id);

            fetchBatch();


        } catch (error) {

        } finally {
            setLoading(false);
        }

    }

    const onProcess = () => {
        setOwnerForProcess(null);
        setTotalQuantityForProcess(null);
        setNotesForProcess(null);
        setProcessStartDate(null);
        setProcessEndDate(null);
        setPackageProductForProcess(null);
        setProcessIn(true);
    }

    const onPackaged = () => {
        setOwnerForPackage(null);
        setTotalQuantityForPackage(null);
        setNotesForPackage(null);
        setPackageProductForPackage(null);
        setStartPackaging(true);
    }

    const handleStartProcess = async () => {
        setLoading(true);
        try {
            if (Number(totalQuantityForProcess) > recordData?.AvailableQuantity) {
                message.warning('Total Quantity for process cannot be greater than available quantity');
                return;
            }

            const body = {
                object_name: "Processing",
                data: {
                    User_id: ownerForProcess ? ownerForProcess : currentUserId,
                    Batch_id: recordData?._id,
                    ProcessingStartDate: processStartDate,
                    PackagingProduct_id: packageProductForProcess ? packageProductForProcess : selectedBagProductForProcess,
                    FinishedProduct_id: selectedFinishedProductForProcess,
                    BatchOutputLineItem_id: stockId,
                    Quantity: totalQuantityForProcess,
                    Note: notesForProcess,
                    ProcessedFrom_id: rawMixProduct?._id

                }
            }


            const apiService = new ApiService(
                `${BASE_URL}/insert_or_update_records`,
                { 'Content-Type': 'application/json' },
                'POST',
                body
            );


            const response = await apiService.makeCall();
            const processsingId = response.id;
            setProcessId(processId);
            const getData = new ApiService(`${BASE_URL}/fetch_records_parent_childs/Processing/Batch_id/${recordData?._id}`, { 'Content-Type': 'application/json' }, 'GET'
            );
            const responseData = await getData.makeCall();
            setProcessId(responseData[0]?._id)
            setProcess(responseData);
            setProcessIn(false);
            fetchBatch();
        } catch (err) {
            const errorMessage = err && typeof err === 'object'
                ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to create due to unknown error';
            message.error(errorMessage);

        } finally {
            setLoading(false);
        }

    }

    const handleStartPackaging = async () => {
        setLoading(true);
        try {
            if (Number(totalQuantityForPackage) > recordData?.AvailableQuantity) {
                message.warning('Total Quantity for package cannot be greater than available quantity');
                return;
            }
            const body = {
                object_name: "PacakgedOutput",
                data: {
                    User_id: ownerForPackage ? ownerForPackage : currentUserId,
                    Batch_id: recordData?._id,
                    Product_id: rawMixProduct?._id,
                    PackagingProduct_id: packageProductForPackage ? packageProductForPackage : selectedBagProductForProcess,
                    Quantity: expectedPackagingBagsForPackage,
                    Note: notesForPackage,
                    BatchOutputLineItem_id: stockId,
                    Weight: totalQuantityForPackage
                }
            }

            const apiService = new ApiService(
                `${BASE_URL}/insert_or_update_records`,
                { 'Content-Type': 'application/json' },
                'POST',
                body
            );


            const response = await apiService.makeCall();

            const packagingId = response.id;
            setPackageId(response.id);

            const getData = new ApiService(`${BASE_URL}/fetch_single_record/PacakgedOutput/${packagingId}`, { 'Content-Type': 'application/json' }, 'GET');
            const responseData = await getData.makeCall();
            setPackage(responseData);
            setStartPackaging(false);

            fetchBatch();



        }
        catch (err) {
            const errorMessage = err && typeof err === 'object'
                ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to create due to unknown error';
            message.error(errorMessage);

        } finally {
            setLoading(false);
        }


    }

    const handleEndProcess = (processItem) => {
        setEndModalVisible(true);
        setProcessItemToEnd(processItem);
        setProcessEndDate(null);

    };

    const saveEndDate = async () => {
        setLoading(true);
        try {
            const body = {
                object_name: "Processing",
                data: {
                    _id: processItemtoEnd?._id,
                    ProccessingEndDateTime: processEndDate
                }
            }
            const apiService = new ApiService(
                `${BASE_URL}/insert_or_update_records`,
                { 'Content-Type': 'application/json' },
                'POST',
                body
            );
            const response = await apiService.makeCall();

            const getProcess = new ApiService(`${BASE_URL}/fetch_records_parent_childs/Processing/Batch_id/${recordData?._id}`, { 'Content-Type': 'application/json' }, 'GET');
            const responseProcess = await getProcess.makeCall();
            setProcessId(responseProcess[responseProcess.length - 1]._id)
            setProcess(responseProcess);

            const getPackage = new ApiService(`${BASE_URL}/fetch_records_parent_childs/PacakgedOutput/Batch_id/${recordData?._id}`, { 'Content-Type': 'application/json' }, 'GET');
            const responsePackage = await getPackage.makeCall();
            setPackageId(responsePackage[responsePackage.length - 1]._id);
            setPackage(responsePackage[responsePackage.length - 1]);
            fetchBatch();
            message.success("Process ended successfully");


        }
        catch (err) {
            const errorMessage = err && typeof err === 'object'
                ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to end due to unknown error';
            message.error(errorMessage);

        }
        finally {
            setProcessQuantityToEnd(null);
            setProcessEndDate(null);
            setHoveredProcess(null);
            setProcessItemToEnd(null);
            setProductForPackageFromProcessing(null);
            setEndModalVisible(false);
            setLoading(false);
        }
    };

    const handleMouseOver = (e, processItem) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setHoverPosition({ top: rect.bottom + window.scrollY, left: rect.left + window.scrollX });
        setHoveredProcess(processItem);
        setHoverVisible(true);
    };


    const onDispatch = () => {
        setDispatchModal(true);
    }

    const handleDispatchBatch = async () => {
        try {

            const body = {
                object_name: "DispatchNote",
                data: {

                    User_id: ownerForDispatch ? ownerForDispatch : currentUserId,
                    Order_id:selectedOrderForDispatch,
                    VehicleNumber:dispatchTruckNumber,
                    DriverName:dispatchDriverName,
                    DispatchDate:dispatchDate


                }
            }

            const apiService = new ApiService(`${BASE_URL}/insert_or_update_records`, { 'Content-Type': 'application/json' }, 'POST', body);
            const response = await apiService.makeCall();   


            fetchBatch();

        }
        catch (err) {
            const errorMessage = err && typeof err === 'object'
                ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                : 'Failed to create due to unknown error';
            message.error(errorMessage);

        }

    }

    return (

        <div style={{ marginBottom: "15px", height: 'auto', overflow: 'auto' }}>
            <Spin spinning={loading} size="medium">
                <Card style={{ padding: '0px' }} bodyStyle={{ padding: 0 }}>
                    <Row gutter={16} align="stretch" style={{ border: "1px solid #d9d9d9", borderRadius: "5px", margin: 0 }}>
                        <Col span={4} style={{ borderRight: "1px solid #d9d9d9", padding: "10px", display: "flex", flexDirection: "column" }}>
                            <Typography.Text style={{ fontSize: '20px' }} strong>Batch Number</Typography.Text>
                            <div style={{ fontSize: '15px', flexGrow: 1 }}>
                                {recordData?.Name ? (
                                    <Link to={`/record/Batch/${recordData._id}`}>{recordData.Name}</Link>
                                ) : ""}
                            </div>
                        </Col>
                        <Col span={5} style={{ borderRight: "1px solid #d9d9d9", padding: "10px", display: "flex", flexDirection: "column" }}>
                            <Typography.Text style={{ fontSize: '18px' }} strong>Created Date</Typography.Text>
                            <div style={{ fontSize: '15px', flexGrow: 1 }}>{recordData?.created_at ? dayjs(recordData.created_at).format("DD/MM/YYYY hh:mm A") : ""}</div>
                        </Col>
                        <Col span={5} style={{ borderRight: "1px solid #d9d9d9", padding: "10px", display: "flex", flexDirection: "column" }}>
                            <Typography.Text style={{ fontSize: '18px' }} strong>Status</Typography.Text>
                            <div style={{ fontSize: '15px', flexGrow: 1 }}>{recordData?.Status || ""}</div>
                        </Col>
                        <Col span={5} style={{ borderRight: "1px solid #d9d9d9", padding: "10px", display: "flex", flexDirection: "column" }}>
                            <div style={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: "2px" }}>
                                <Typography.Text style={{ fontSize: '16px' }} strong>{rawMixProduct?.Name}</Typography.Text>
                                <Typography.Text style={{ fontSize: '14px' }} strong>Total Quantity</Typography.Text>
                                <Typography.Text style={{ fontSize: '14px' }}>
                                    {recordData?.TotalQuantity ? `${recordData?.TotalQuantity?.toFixed(2)} ` : "0.00"} Metric Tons
                                </Typography.Text>
                                <Typography.Text style={{ fontSize: '14px' }} strong>Available Quantity</Typography.Text>
                                <Typography.Text style={{ fontSize: '14px' }}>
                                    {recordData?.AvailableQuantity ? recordData?.AvailableQuantity : "0.00"} Metric Tons
                                </Typography.Text>
                            </div>
                        </Col>
                        <Col span={5} style={{ borderRight: "1px solid #d9d9d9", padding: "10px", display: "flex", flexDirection: "column" }}>
                            <div style={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: "2px" }}>
                                <Typography.Text style={{ fontSize: '18px' }} strong>{finalFinishedProduct?.Name}</Typography.Text>
                                <Typography.Text style={{ fontSize: '14px' }} strong>Total Output Quantity</Typography.Text>
                                <Typography.Text style={{ fontSize: '14px' }}>
                                    {recordData?.TotalFinishedProductQuantity ? `${recordData?.TotalFinishedProductQuantity?.toFixed(2)}` : "0.00"} Metric Tons
                                </Typography.Text>
                            </div>
                        </Col>
                    </Row>
                </Card>

                <Card style={{ marginTop: '20px', height: '500px' }}>
                    <Row gutter={20} style={{ marginTop: '10px' }}>
                        <Col
                            span={6}
                            style={{
                                height: "400px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between", // Adjusts spacing
                                alignItems: "center", // Centers button horizontally
                                padding: "10px",
                            }}
                            className="hover-effect"
                        >
                            <Title level={4} style={{ marginBottom: "5px" }}>
                                {recordData?.Name}
                            </Title>
                            <div style={{ fontSize: '15px' }}>{recordData?.created_at ? dayjs(recordData.created_at).format("DD/MM/YYYY hh:mm A") : ""}</div>

                            <div style={{ width: "100%", height: "calc(100% - 40px)", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                {pieData.length > 0 ? (
                                    <ResponsivePie
                                        data={pieData}
                                        margin={{ top: 10, right: 10, bottom: 10, left: 10 }} // Adjust margins for better fit
                                        innerRadius={0.5}
                                        padAngle={0.7}
                                        cornerRadius={3}
                                        colors={{ scheme: "category10" }}
                                        borderWidth={1}
                                        borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
                                        radialLabelsSkipAngle={10}
                                        radialLabelsTextXOffset={6}
                                        radialLabelsTextColor="#333333"
                                        radialLabelsLinkColor={{ from: "color" }}
                                        sliceLabelsSkipAngle={10}
                                        sliceLabelsTextColor="#FFFFFF"
                                    />
                                ) : (
                                    <Spin size="large" />
                                )}
                            </div>

                            <Button
                                disabled={requestForApproval || approved || pendingForApproval}
                                style={{
                                    width: "100%",
                                    backgroundColor: approved ? "green" : undefined,
                                    color: approved ? "white" : undefined,
                                }}
                                onClick={onApproval}
                            >
                                {pendingForApproval
                                    ? "Pending for Approval"
                                    : approved
                                        ? "Approved"
                                        : "Submit for Approval"}
                            </Button>


                        </Col>

                        <Col span={6} className="hover-effect" style={{ height: "400px" }}>
                            <Title level={4} style={{ marginBottom: "10px" }}>
                                Stock
                            </Title>
                            <Button type="primary" disabled={stockId || !approved} style={{ width: "100%", marginBottom: '10px' }} onClick={onStockIn}>
                                Stock In
                            </Button>

                            {stockId && (
                                <>

                                    <Typography.Text style={{ fontSize: '18px', }} strong>Stock Name</Typography.Text>
                                    <div style={{ fontSize: '15px', marginBottom: '5px' }}>
                                        {stock?.Name ? (
                                            <Link to={`/record/BatchOutputLineItem/${stock._id}`}>{stock.Name}</Link>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <Typography.Text style={{ fontSize: '18px' }} strong>Output Product</Typography.Text>
                                    <div style={{ fontSize: '15px', marginBottom: '5px' }}>{rawMixProduct?.Name || ""}</div>

                                    <Typography.Text style={{ fontSize: '18px' }} strong>Total Quantity</Typography.Text>
                                    <div style={{ fontSize: '15px', marginBottom: '5px' }}>{stock?.Quantity ? stock?.Quantity?.toFixed(2) : "0.00"} Metric Tons</div>

                                    <Typography.Text style={{ fontSize: '18px' }} strong>Available Quantity</Typography.Text>
                                    <div style={{ fontSize: '15px', marginBottom: '5px' }}>{recordData?.AvailableQuantity ? recordData?.AvailableQuantity : "0.00"} Metric Tons</div>

                                    <Typography.Text style={{ fontSize: '18px' }} strong>Created Date</Typography.Text>
                                    <div style={{ fontSize: '15px', marginBottom: '5px' }}>{dayjs(stock?.created_at).format('DD/MM/YYYY hh:mm A') || ""}</div>

                                    <Typography.Text style={{ fontSize: '18px' }} strong>Note</Typography.Text>
                                    <div style={{ fontSize: '15px', marginBottom: '5px' }}>{stock?.Note || ""}</div>
                                </>
                            )}
                        </Col>
                        <Col span={6} className="hover-effect" style={{ height: "400px" }}>
                            <Title level={4} style={{ marginBottom: "10px" }}>
                                Processed
                            </Title>
                            <Button disabled={!stockId || recordData?.AvailableQuantity === 0 || recordData?.AvailableQuantity<0}
                                type="primary" style={{ width: "100%", marginBottom: '10px' }} onClick={onProcess}>
                                Process In
                            </Button>
                            {process?.length > 0 &&
                                process?.map((processItem, index) => (
                                    <div
                                        key={processItem._id}
                                        style={{ marginBottom: "15px", position: "relative" }}
                                        onMouseOver={(e) => handleMouseOver(e, processItem)}
                                        onMouseLeave={() => {
                                            setHoveredProcess(null);
                                            setHoverVisible(false);
                                        }
                                        }
                                    >
                                        {(hoveredProcess?._id === processItem?._id) && hoverVisible && (
                                            <div
                                                style={{
                                                    pointerEvents: "auto"
                                                }}>
                                                <HoverCard
                                                    processItem={hoveredProcess}
                                                    visible={hoverVisible}
                                                    onClose={() => setHoverVisible(false)}
                                                    onEndProcess={handleEndProcess}
                                                />
                                            </div>
                                        )}
                                        <div
                                            key={processItem?._id}
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "8px",
                                                marginBottom: "5px"
                                            }}
                                        >


                                            {/* Container for Name and Quantity */}
                                            <div style={{ display: "flex", flexDirection: "column", width: '100%' }}>
                                                <div style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between', gap: "8px" }}>
                                                    <div>
                                                        <Typography.Text style={{ fontSize: "18px" }} strong>
                                                            {index + 1}.
                                                        </Typography.Text>
                                                        <Typography.Text style={{ fontSize: "14px", marginRight: '14px' }}>
                                                            {processItem?.Name ? (
                                                                <>
                                                                    <a href={`/record/Processing/${processItem?._id}`}>{processItem?.Name}</a>{" "}
                                                                    ({processItem?.Quantity ? processItem?.Quantity?.toFixed(2) : "0.00"} mt)
                                                                </>) : (
                                                                ""
                                                            )}
                                                        </Typography.Text>
                                                    </div>
                                                    <div>
                                                        <Button
                                                            type="primary"
                                                            size="small"
                                                            onClick={() => {
                                                                handleEndProcess(processItem);
                                                            }}
                                                            disabled={!!processItem?.ProccessingEndDateTime} // Disable button if not empty
                                                        >
                                                            {processItem.ProccessingEndDateTime ? "Ended" : "End"}
                                                        </Button>
                                                    </div>
                                                </div>
                                               
                                            </div>
                                        </div>

                                    </div>

                                ))}

                        </Col>
                        <Col span={6} className="hover-effect" style={{ height: "400px" }}>
                            <Title level={4} style={{ marginBottom: "10px" }}>
                                Packaged
                            </Title>
                            <Button disabled={!stockId || recordData?.AvailableQuantity === 0 ||  recordData?.AvailableQuantity<0} type="primary" style={{ width: "100%", marginBottom: '10px' }} onClick={onPackaged}>
                                Package In
                            </Button>

                            {packageId && (
                                <>
                                    <Typography.Text style={{ fontSize: '18px', }} strong>Package Name</Typography.Text>
                                    <div style={{ fontSize: '15px', marginBottom: '5px' }}>
                                        {packaging?.Name ? (
                                            <Link to={`/record/PacakgedOutput/${packaging._id}`}>{packaging.Name}</Link>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <Typography.Text style={{ fontSize: '18px' }} strong>Packaging Batch</Typography.Text>
                                    <div style={{ fontSize: '15px', marginBottom: '5px' }}>{packaging?.Batch?.Name || ""}</div>

                                    <Typography.Text style={{ fontSize: '18px' }} strong>Packaging Product</Typography.Text>
                                    <div style={{ fontSize: '15px', marginBottom: '5px' }}>{packaging?.PackagingProduct?.Name || ""}</div>

                                    <Typography.Text style={{ fontSize: '18px' }} strong>Packaged Product</Typography.Text>
                                    <div style={{ fontSize: '15px', marginBottom: '5px' }}>{packaging?.Product?.Name || ""}</div>

                                    <Typography.Text style={{ fontSize: '18px' }} strong>Total Quantity</Typography.Text>
                                    <div style={{ fontSize: '15px', marginBottom: '5px' }}>{packaging?.Quantity ? `${packaging.Quantity} Bags/Bucket` : ""}</div>

                                </>
                            )}
                        </Col>
                        {/* <Col span={4} className="hover-effect" style={{ height: "400px" }}>
                            <Title level={4} style={{ marginBottom: "10px" }}>
                                Dispatched
                            </Title>
                            <Button type="primary" style={{ width: "100%", marginBottom: '10px' }} onClick={onDispatch}>
                                Dispatch
                            </Button>


                        </Col> */}
                    </Row>

                    <style>
                        {`
                            .hover-effect {
                                background: #fff;
                                border-radius: 8px;
                                transition: all 0.3s ease-in-out;
                                padding: 10px;
                            }

                            .hover-effect:hover {
                                box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
                                transform: translateY(-5px);
                            }
                        `}
                    </style>

                </Card>



                <Modal
                    title="Confirm Stock In"
                    visible={stockIn}
                    onCancel={() => setStockIn(false)}
                    onOk={handleStockInConfirm}
                    okText="Confirm"
                    cancelText="Cancel"
                    zIndex={1002}   // higher than sidebar
                    width={700} // Adjust width as needed
                    bodyStyle={{ maxHeight: "90vh" }}
                >
                    <Spin spinning={loading}>
                        <Row gutter={16}> {/* Adds space between columns */}
                            <Col span={12}> {/* Each column takes half width */}
                                <div>
                                    <Typography.Text strong>User</Typography.Text>
                                    <Input
                                        disabled
                                        value={CurrenctUserName}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Batch Number</Typography.Text>
                                    <Input
                                        disabled
                                        value={recordData?.Name}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}> {/* Adds space between columns */}
                            <Col span={12}> {/* Each column takes half width */}
                                <div>
                                    <Typography.Text strong>Product</Typography.Text>
                                    <Input
                                        disabled
                                        value={rawMixProduct?.Name}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Batch Date and Time</Typography.Text>
                                    <Input
                                        disabled={true}
                                        style={{ width: '100%' }}
                                        value={batchDateTime}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16}> {/* Adds space between columns */}
                            <Col span={12}> {/* Each column takes half width */}
                                <div>
                                    <Typography.Text strong>Total Quantity</Typography.Text>
                                    <Input
                                        disabled
                                        value={recordData.TotalQuantity}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    />
                                </div>
                            </Col>

                        </Row>

                        <Row>
                            <Col span={24}>
                                <div>
                                    <Typography.Text strong>Notes</Typography.Text>
                                    <Input.TextArea
                                        style={{ width: '100%' }}
                                        value={notes}
                                        placeholder="Add note"
                                        onChange={(e) => setNotes(e.target.value)}
                                        autoSize={{ minRows: 3, maxRows: 6 }} // Adjusts height dynamically
                                    />
                                </div>

                            </Col>
                        </Row>

                        <p>Are you sure you want to proceed with stock in?</p>
                    </Spin>
                </Modal>

                <Modal
                    title="Confirm Process"
                    visible={processIn}
                    onCancel={() => setProcessIn(false)}
                    onOk={handleStartProcess}
                    okText="Confirm"
                    zIndex={1002}   // higher than sidebar
                    cancelText="Cancel"
                    width={700} // Adjust width as needed
                    bodyStyle={{ maxHeight: "90vh" }}
                >
                    <Spin spinning={loading}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Owner</Typography.Text>
                                    <Select
                                        value={ownerForProcess ? ownerForProcess : currentUserId}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                        onChange={(e) => setOwnerForProcess(e.target.value)}
                                    >
                                        {users.map((user) => (
                                            <Option key={user._id} value={user._id}>
                                                {user.Name}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Batch Number</Typography.Text>
                                    <Input
                                        disabled
                                        value={recordData?.Name}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Select Finished Product</Typography.Text>
                                    <Select
                                        showSearch
                                        placeholder="Select Product"
                                        onChange={(e) => setSelectedFinishedProductForProcess(e)}
                                        style={{ width: '100%' }}
                                        value={selectedFinishedProductForProcess}
                                    >
                                        {allFinishedProducts.map((product) => (
                                            <Option key={product._id} value={product._id}>
                                                {product.Name}
                                            </Option>
                                        ))}

                                    </Select>
                                </div>
                            </Col>

                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Select Pakckaged Product</Typography.Text>
                                    <Select
                                        showSearch
                                        placeholder="Select Packaging Product"
                                        onChange={(e) => setPackageProductForProcess(e)}
                                        style={{ width: '100%' }}
                                        value={packageProductForProcess ? packageProductForProcess : selectedBagProductForProcess}
                                    >
                                        {allBagProducts.map((product) => (
                                            <Option key={product._id} value={product._id}>
                                                {product.Name}
                                            </Option>
                                        ))}

                                    </Select>
                                </div>
                            </Col>

                        </Row>


                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Available Quantity</Typography.Text>
                                    <Input
                                        disabled
                                        value={recordData?.AvailableQuantity}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                        addonAfter={"mt"}
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Total Quantity</Typography.Text>
                                    <Input
                                        type="number"
                                        value={totalQuantityForProcess}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                        onChange={(e) => {
                                            setTotalQuantityForProcess(e.target.value);
                                            var quant;

                                            if (packageProductForProcess) {
                                                const selectedProduct = allBagProducts.find((product) => product?._id === packageProductForProcess);
                                                quant = ((e.target.value) * 1000) / selectedProduct?.BagWeight;

                                            } else {
                                                const selectedProduct = allBagProducts.find((product) => product?._id === selectedBagProductForProcess);
                                                quant = ((e.target.value) * 1000) / selectedProduct?.BagWeight;
                                            }
                                            setExpectedPackagingBagsForProcess(quant);
                                        }
                                        }
                                        addonAfter={"mt"}
                                    />
                                </div>
                            </Col>

                        </Row>



                        <Row gutter={16} style={{ marginBottom: "10px" }}> {/* Adds space between columns */}
                            <Col span={12}> {/* Each column takes half width */}
                                <div>
                                    <Typography.Text strong>Proccessing Start Date and Time</Typography.Text>
                                    <DatePicker
                                        showTime
                                        style={{ width: '100%' }}
                                        value={processStartDate ? dayjs(processStartDate, "DD/MM/YYYY hh:mm A") : dayjs()} // Ensure correct parsing
                                        format="DD/MM/YYYY hh:mm A"
                                        onChange={(date, dateString) => {
                                            setProcessStartDate(dateString); // Store correct format
                                        }}

                                    />
                                </div>
                            </Col>

                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Expected Packaging Bags/Buckets</Typography.Text>
                                    <Input
                                        disabled
                                        addonAfter={"Bags/Bucket"}
                                        value={expectedPackagingBagsForProcess ? expectedPackagingBagsForProcess : 0}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={24}>
                                <div>
                                    <Typography.Text strong>Notes</Typography.Text>
                                    <Input.TextArea
                                        style={{ width: '100%' }}
                                        value={notesForProcess}
                                        placeholder="Add note"
                                        onChange={(e) => setNotesForProcess(e.target.value)}
                                        autoSize={{ minRows: 3, maxRows: 6 }} // Adjusts height dynamically
                                    />
                                </div>

                            </Col>
                        </Row>



                        <p>Are you sure you want to proceed with process in?</p>
                    </Spin>
                </Modal>

                <Modal
                    title="Confirm Packaging"
                    visible={startPackaging}
                    onCancel={() => setStartPackaging(false)}
                    onOk={handleStartPackaging}
                    okText="Confirm"
                    zIndex={1002}   // higher than sidebar
                    cancelText="Cancel"
                    width={700} // Adjust width as needed
                    bodyStyle={{ maxHeight: "90vh" }}
                >
                    <Spin spinning={loading}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Owner</Typography.Text>
                                    <Select
                                        value={ownerForPackage ? ownerForPackage : currentUserId}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                        onChange={(e) => setOwnerForPackage(e.target.value)}

                                    >
                                        {users.map((user) => (
                                            <Option key={user._id} value={user._id}>
                                                {user.Name}
                                            </Option>
                                        ))}

                                    </Select>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Batch Number</Typography.Text>
                                    <Input
                                        disabled
                                        value={recordData?.Name}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Packaged Product</Typography.Text>
                                    <Input
                                        showSearch
                                        disabled={true}
                                        style={{ width: '100%' }}
                                        value={rawMixProduct?.Name}
                                    >
                                    </Input>
                                </div>
                            </Col>

                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Select Packaging Product</Typography.Text>
                                    <Select
                                        showSearch
                                        placeholder="Select Packaging Product"
                                        onChange={(e) => setPackageProductForPackage(e)}
                                        style={{ width: '100%' }}
                                        value={packageProductForPackage ? packageProductForPackage : selectedBagProductForProcess}
                                    >
                                        {allBagProducts.map((product) => (
                                            <Option key={product?._id} value={product?._id}>
                                                {product?.Name}
                                            </Option>
                                        ))}

                                    </Select>
                                </div>
                            </Col>

                        </Row>


                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Available Quantity</Typography.Text>
                                    <Input
                                        disabled
                                        value={recordData?.AvailableQuantity}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Total Quantity</Typography.Text>
                                    <Input

                                        value={totalQuantityForPackage}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                        onChange={(e) => {
                                            setTotalQuantityForPackage(e.target.value);
                                            var quant;

                                            if (packageProductForPackage) {
                                                const selectedProduct = allBagProducts.find((product) => product?._id === packageProductForPackage);
                                                quant = ((e.target.value) * 1000) / selectedProduct?.BagWeight;

                                            } else {
                                                const selectedProduct = allBagProducts.find((product) => product?._id === selectedBagProductForProcess);
                                                quant = ((e.target.value) * 1000) / selectedProduct?.BagWeight;
                                            }
                                            setExpectedPackagingBagsForPackage(quant);
                                        }
                                        }
                                        addonAfter={"mt"}
                                    />
                                </div>
                            </Col>

                        </Row>

                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Expected Packaging Bags/Buckets</Typography.Text>
                                    <Input
                                        disabled
                                        addonAfter={"Bags/Bucket"}
                                        value={expectedPackagingBagsForPackage ? expectedPackagingBagsForPackage : 0}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    />
                                </div>
                            </Col>
                        </Row>



                        <Row>
                            <Col span={24}>
                                <div>
                                    <Typography.Text strong>Notes</Typography.Text>
                                    <Input.TextArea
                                        style={{ width: '100%' }}
                                        value={notesForPackage}
                                        placeholder="Add note"
                                        onChange={(e) => setNotesForPackage(e.target.value)}
                                        autoSize={{ minRows: 3, maxRows: 6 }} // Adjusts height dynamically
                                    />
                                </div>

                            </Col>
                        </Row>



                        <p>Are you sure you want to proceed with Packaged in?</p>
                    </Spin>
                </Modal>

                <Modal
                    title="Package This Process"
                    visible={EndmodalVisible}
                    onCancel={() => {
                        setProcessItemToEnd(null);
                        setEndModalVisible(false)
                    }}
                    onOk={saveEndDate}
                    zIndex={1002}   // higher than sidebar
                >
                    <Spin spinning={loading}> {/* Wrap modal content with Spin */}

                        <Typography.Text strong>Name</Typography.Text>
                        <Input value={processItemtoEnd?.Name} disabled style={{ fontSize: "15px", marginBottom: "10px" }} />

                        <Typography.Text strong>Batch Name</Typography.Text>
                        <Input value={processItemtoEnd?.Batch?.Name} disabled style={{ fontSize: "15px", marginBottom: "10px" }} />

                        <Typography.Text strong>Package Product</Typography.Text>
                        <Input value={processItemtoEnd?.PackagingProduct?.Name} disabled style={{ fontSize: "15px", marginBottom: "10px" }} />

                        <Typography.Text strong>Finished Product</Typography.Text>
                        <Input value={processItemtoEnd?.Name} disabled style={{ fontSize: "15px", marginBottom: "10px" }} />

                        <Typography.Text strong>Quantity</Typography.Text>
                        <Input addonAfter={"mt"} value={processItemtoEnd?.Quantity} disabled style={{ fontSize: "15px", marginBottom: "10px" }} />

                        <Typography.Text strong>Start Date</Typography.Text>
                        <Input
                            value={processItemtoEnd?.ProcessingStartDate ? dayjs(processItemtoEnd?.ProcessingStartDate).utc().format("DD/MM/YYYY hh:mm A") : ""}
                            disabled
                            style={{ fontSize: "15px", marginBottom: "10px" }}
                        />

                        <Typography.Text style={{ fontSize: '14px', }} strong>End Date</Typography.Text>
                        <DatePicker
                            format="DD/MM/YYYY hh:mm A"
                            value={processEndDate ? dayjs(processEndDate, "DD/MM/YYYY hh:mm A") : dayjs()}
                            onChange={(date) => setProcessEndDate(date)}
                            style={{ width: "100%" }} />
                    </Spin>
                </Modal>

                {/* <Modal
                    title="Confirm Dispatch"
                    visible={dispatchModal}
                    onCancel={() => {
                        setDispatchModal(false)
                    }}
                    onOk={handleDispatchBatch}
                >
                    <Spin spinning={loading}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Owner</Typography.Text>
                                    <Select
                                        value={ownerForDispatch ? ownerForDispatch : currentUserId}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                        onChange={(e) => setOwnerForDispatch(e.target.value)}
                                    >
                                        {users.map((user) => (
                                            <Option key={user._id} value={user._id}>
                                                {user.Name}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Batch Number</Typography.Text>
                                    <Input
                                        disabled
                                        value={recordData?.Name}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Select Order</Typography.Text>
                                    <Select
                                        showSearch
                                        placeholder="Select Order"
                                        onChange={(e) => setSelectedOrderForDispatch(e)}
                                        style={{ width: '100%' }}
                                        value={selectedOrderForDispatch}
                                    >
                                        {order.map((order) => (
                                            <Option key={order._id} value={order._id}>
                                                {order.Name}
                                            </Option>
                                        ))}

                                    </Select>
                                </div>
                            </Col>

                            <Col span={12}>
                                <Typography.Text style={{ fontSize: '14px', }} strong>Dispatch Date</Typography.Text>
                                <DatePicker
                                    format="DD/MM/YYYY hh:mm A"
                                    value={dispatchDate ? dayjs(dispatchDate, "DD/MM/YYYY hh:mm A") : dayjs()}
                                    onChange={(date) => setDispatchDate(date)}
                                    style={{ width: "100%" }} />
                            </Col>

                        </Row>

                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Vehicle Number</Typography.Text>
                                    <Input
                                        value={dispatchTruckNumber}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                        onChange={(e) => {
                                            setDispatchTruckNumber(e.target.value);
                                        }
                                        }
                                    />
                                </div>
                            </Col>

                            <Col span={12}>
                                <div>
                                    <Typography.Text strong>Driver name</Typography.Text>
                                    <Input
                                        value={dispatchDriverName}
                                        style={{ width: '100%', marginBottom: '10px' }}
                                        onChange={(e) => {
                                            setDispatchDriverName(e.target.value);
                                        }
                                        }
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={24}>
                                <div>
                                    <Typography.Text strong>Notes</Typography.Text>
                                    <Input.TextArea
                                        style={{ width: '100%' }}
                                        value={notesForProcess}
                                        placeholder="Add note"
                                        onChange={(e) => setNotesForProcess(e.target.value)}
                                        autoSize={{ minRows: 3, maxRows: 6 }} // Adjusts height dynamically
                                    />
                                </div>

                            </Col>
                        </Row>





                        <p>Are you sure you want to proceed with dispatch?</p>
                    </Spin>
                </Modal> */}



            </Spin>
        </div>



    );
};

export default SummaryTab;
